import React from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import Card from '@/components/common/Card';
import recordsImage from '@/components/common/icons/records.svg';
import userImage from '@/components/common/icons/user-circle.svg';
import Spinner from '@/components/common/Spinner';

const PackagePurchaseComponent = ({ id, intl, loading, busy, onChange, onSubmit, packages, status }) =>
  loading ? (
    <div className="flex justify-center items-center flex-1 p-20">
      <Spinner />
    </div>
  ) : (
    <div className="flex flex-col p-[1.5em_1em] gap-[0.6em]">
      <Card className="fade-in !m-0">
        <h2
          className="flex items-center !text-[1.25em] !font-bold !leading-[1.3] !mb-[1.4em] !pb-[1.4em] border-b border-[#eee]"
          style={{ color: '#393939' }}
        >
          <div className="flex-shrink-0 mr-[0.5em]">
            <Link
              to={`/clients/${status}/${id}`}
              className="relative top-[2px] flex items-center justify-center w-[24px] h-[24px] border-0 p-0 bg-transparent"
            >
              <div
                className="relative left-[4px] w-[14px] h-[14px] rotate-45 transition-colors"
                style={{ border: '2px solid #c1c1c1', borderTop: 0, borderRight: 0 }}
              />
            </Link>
          </div>

          <div className="flex-shrink-0mr-[0.5em] flex items-center">
            <img
              src={recordsImage}
              alt={intl.formatMessage({ id: 'EXTRACT' })}
              className="w-full h-full max-w-[28px]"
            />
          </div>

          {intl.formatMessage({ id: 'ADD_PACKAGE' })}
        </h2>

        <h3
          className="flex items-center !text-[0.93875em] !font-bold !leading-[1.1] !mt-0 !mb-0"
          style={{ color: '#393939' }}
        >
          <div className="flex-shrink-0 w-[3.46em] inline-flex items-center">
            <img
              src={userImage}
              alt={intl.formatMessage({ id: 'CUSTOMER' })}
              className="h-[24px] w-[24px]"
            />
          </div>
          {intl.formatMessage({ id: 'AVAILABLE_PACKAGES' })}
        </h3>

        <form onSubmit={onSubmit}>
          <ul className="list-none !m-[1.875em_0] !p-[0_3.3125em]">
            {packages.map(item => (
              <li className="!mt-[1.25em] first:!mt-0" key={item.id}>
                <input
                  type="radio"
                  name="package"
                  value={item.id}
                  id={`pacote-${item.id}`}
                  onChange={onChange}
                  className="absolute opacity-0 pointer-events-none peer"
                />
                <label
                  htmlFor={`pacote-${item.id}`}
                  className="!flex justify-between items-center !w-full !h-[50px] !m-0 !px-[1.4375em] !border-2 !border-[#e3e3e3] !rounded-[3px] !cursor-pointer !normal-case !text-[1em] !font-normal peer-checked:!border-[#a6a6a6] peer-checked:shadow-[inset_0_0_0_1px_#a6a6a6] transition-all"
                  style={{ color: '#393939' }}
                >
                  <div className="text-[1em] font-bold">{item.name}</div>
                  <div className="text-[0.75em]">{item.credits}</div>
                </label>
              </li>
            ))}
          </ul>

          <div className="flex justify-center !mt-[1.75em] !pt-[1.75em] border-t border-[#eeeeee] gap-[0.5rem]">
            <Link
              to={`/clients/${status}/${id}`}
              className="inline-flex justify-center items-center min-w-[140px] h-[36px] px-[1.2rem] border-0 rounded-[3px] bg-[#c1c1c1] text-[0.875rem] font-bold text-white no-underline hover:opacity-75 transition-opacity"
            >
              {intl.formatMessage({ id: 'CANCEL' })}
            </Link>
            <button
              type="submit"
              disabled={busy}
              className="inline-flex justify-center items-center min-w-[140px] h-[36px] px-[1.2rem] border-0 rounded-[3px] bg-[#97a500] text-[0.875rem] font-bold text-white hover:opacity-75 transition-opacity disabled:cursor-not-allowed"
            >
              {intl.formatMessage({ id: 'ADD' })}
            </button>
          </div>
        </form>

      </Card>
    </div>
  );

PackagePurchaseComponent.propTypes = {
  id: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  busy: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  packages: PropTypes.array.isRequired,
  status: PropTypes.string.isRequired,
};

export default PackagePurchaseComponent;
